// Import the redux-saga/effects
import {call, put, takeEvery} from 'redux-saga/effects'

// Import all action and api's
import {DELETE_FILE, GET_ALL_UPLOAD_FILES, UPLOAD_FILE, UPLOAD_FILE_EXPENSE_REPORT, UPLOAD_JOB_FILE} from '../action-types'

// Import all api's
import {
    deleteFileRequest,
    getAllUploadFilesRequest,
    uploadFileExpenseReportRequest,
    uploadFileRequest,
    uploadJobFileRequest
} from '../api/File'

import {
    deleteFileSuccess,
    getAllUploadFilesSuccess,
    uploadFileExpenseReportSuccess,
    uploadFileContractorInvoiceSuccess,
    uploadFileSuccess,
    uploadJobFileSuccess
} from '../actions/File'

import {fetchError, fetchExpired, fetchStart, fetchSuccess} from '../actions/Common'
import { toast } from 'react-toastify'

function* getAllUploadFiles({token}) {
    try {
        //yield put(fetchStart())
        const response = yield call(getAllUploadFilesRequest, token)

        if (response.status === 200) {
            if (response.data.errors && response.data.errors.length > 0) {
                yield put(fetchError(response.data))
            } else {
                yield put(getAllUploadFilesSuccess(response.data))
                yield put(fetchSuccess())
            }
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.log(error)
    }
}

function* uploadFile({token, values, intl}) {
    try {
        yield put(fetchStart())
        const response = yield call(uploadFileRequest, token, values)
        if (response.status === 200) {
            if (response.data.errors && response.data.errors.length > 0) {
                yield put(fetchError(response.data))
            } else {
                yield put(uploadFileSuccess(response.data))
                yield put(fetchSuccess())
            }
        }
        if (response.status === 401) {
            yield put(fetchExpired())
            toast.error(intl.formatMessage({ id: "error401" }));
        }
        if (response.status === 403) {
            toast.error(intl.formatMessage({id: "accessDeniedMessage"}))
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
            toast.error(intl.formatMessage({ id: "server_error_portage" }));
        }
    } catch (error) {
        console.log(error)
        toast.error(intl.formatMessage({ id: "global_error_portage" }));
    }
}

function* uploadJobFile({token, values, intl}) {
    try {
        yield put(fetchStart())
        const response = yield call(uploadJobFileRequest, token, values)
        if (response.status === 200) {
            if (response.data.errors && response.data.errors.length > 0) {
                yield put(fetchError(response.data))
            } else {
                yield put(uploadJobFileSuccess(response.data))
                yield put(fetchSuccess())
               toast.success(intl.formatMessage({id:"uploadedFile"}))
            }
        }
        if (response.status === 401) {
            yield put(fetchExpired())
            toast.error(intl.formatMessage({ id: "error401" }));
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
            toast.error(intl.formatMessage({ id: "server_error_portage" }));
        }
    } catch (error) {
        console.log(error)
        toast.error(intl.formatMessage({ id: "global_error_portage" }));
    }
}

function* uploadFileExpenseReport({token, values}) {
    try {
        yield put(fetchStart())
        const response = yield call(uploadFileExpenseReportRequest, token, values)
        if (response.status === 200) {
            if (response.data.errors && response.data.errors.length > 0) {
                yield put(fetchError(response.data))
            } else {
                if (values?.type == 'expense_report') {
                    yield put(uploadFileExpenseReportSuccess(response.data))
                }
                if (values?.type == 'contractor_invoice') {
                    yield put(uploadFileContractorInvoiceSuccess(response.data))
                }
                if (values?.type == 'holiday_request') {
                    yield put(uploadFileExpenseReportSuccess(response.data))
                }
                yield put(fetchSuccess())
            }
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.log(error)
    }
}

function* deleteFile({token, id}) {
    try {
        yield put(fetchStart())
        const response = yield call(deleteFileRequest, token, id)
        if (response.status === 200) {
            if (response.data.errors && response.data.errors.length > 0) {
                yield put(fetchError(response.data))
            } else {
                yield put(deleteFileSuccess(response.data))
                yield put(fetchSuccess())
            }
        }
        if (response.status === 401) {
            yield put(fetchExpired())
        }
        if (response.status === 500) {
            yield put(fetchError(response.data))
        }
    } catch (error) {
        console.log(error)
    }
}

// Export the saga (todo-saga)
export default function* todoSaga() {
    yield takeEvery(GET_ALL_UPLOAD_FILES, getAllUploadFiles)
    yield takeEvery(UPLOAD_FILE, uploadFile)
    yield takeEvery(UPLOAD_FILE_EXPENSE_REPORT, uploadFileExpenseReport)
    yield takeEvery(DELETE_FILE, deleteFile)
    yield takeEvery(UPLOAD_JOB_FILE, uploadJobFile)
}